import { useEffect } from "react";

function inputByLabel(form:HTMLFormElement,labelText:string){
  const label=[...form.querySelectorAll<HTMLLabelElement>("label")].find(x=>{
    const text=(x.childNodes[0]?.textContent||x.textContent||"").trim().toLowerCase();
    return text.startsWith(labelText.toLowerCase());
  });
  return label?.querySelector<HTMLInputElement>("input")||null;
}

function qualificationSelect(form:HTMLFormElement){
  const label=[...form.querySelectorAll<HTMLLabelElement>("label")].find(x=>{
    const text=(x.childNodes[0]?.textContent||x.textContent||"").trim().toLowerCase();
    return text.startsWith("qualification")&&!text.startsWith("qualification program");
  });
  return label?.querySelector<HTMLSelectElement>("select")||null;
}

function protectExpiry(form:HTMLFormElement){
  if(!form.closest(".qualification-record-panel"))return;
  const heading=form.querySelector("h2")?.textContent?.trim().toLowerCase()||"";
  if(!heading.includes("qualification"))return;
  const expiry=inputByLabel(form,"Expiry");
  if(!expiry)return;
  const category=qualificationSelect(form)?.value||"";

  // QualificationRecordManager already recalculates expiry whenever the pass date
  // changes. This guard only prevents manual editing of the calculated field.
  // Do not dispatch input/change events here: doing so can overwrite the supervisor's
  // newly entered pass date with stale React form state.
  expiry.disabled=true;
  expiry.title=category==="TW"
    ?"Tack-weld qualifications do not expire."
    :"Calculated automatically as two years from the pass date.";
}

export default function QualificationExpiryGuard(){
  useEffect(()=>{
    const protectAll=()=>document.querySelectorAll<HTMLFormElement>(".qualification-record-panel form").forEach(protectExpiry);
    const onChange=(event:Event)=>{
      const target=event.target as HTMLElement;
      const form=target.closest<HTMLFormElement>(".qualification-record-panel form");
      if(form)queueMicrotask(()=>protectExpiry(form));
    };
    document.addEventListener("change",onChange,true);
    const observer=new MutationObserver(protectAll);
    observer.observe(document.body,{childList:true,subtree:true});
    protectAll();
    return()=>{
      document.removeEventListener("change",onChange,true);
      observer.disconnect();
    };
  },[]);
  return null;
}
